// Mock data for Max Bien Software Company

export const companyInfo = {
  name: "Max Bien",
  tagline: "Transforming Ideas into Digital Excellence",
  description: "A leading software company specializing in custom software development, web/mobile applications, and cloud solutions.",
  mission: "We empower businesses with innovative technology solutions that drive growth and efficiency.",
  email: "info@maxbien.com",
  phone: "+91 93204-93104",
  address: "Bengaluru, Karnataka 560034"
};

export const services = [
  {
    id: 1,
    title: "Custom Software Development",
    description: "Tailored solutions designed to meet your unique business requirements. From concept to deployment, we build scalable and maintainable software.",
    icon: "Code2",
    features: [
      "Enterprise applications",
      "API development & integration",
      "Legacy system modernization",
      "Microservices architecture"
    ]
  },
  {
    id: 2,
    title: "Web & Mobile App Development",
    description: "Create stunning, user-friendly applications that work seamlessly across all devices and platforms.",
    icon: "Smartphone",
    features: [
      "Progressive Web Apps (PWA)",
      "iOS & Android native apps",
      "Cross-platform solutions",
      "Responsive web design"
    ]
  },
  {
    id: 3,
    title: "Cloud Services",
    description: "Leverage the power of cloud computing to scale your business and reduce infrastructure costs.",
    icon: "Cloud",
    features: [
      "Cloud migration & consulting",
      "DevOps & CI/CD pipelines",
      "Infrastructure as Code",
      "Cloud security & compliance"
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "FinTech Payment Platform",
    category: "Custom Software",
    description: "A secure, scalable payment processing system handling millions of transactions.",
    technologies: ["React", "Node.js", "PostgreSQL", "AWS"],
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80"
  },
  {
    id: 2,
    title: "Healthcare Management System",
    category: "Web Application",
    description: "Complete patient management solution for modern healthcare providers.",
    technologies: ["Vue.js", "Python", "MongoDB", "Docker"],
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80"
  },
  {
    id: 3,
    title: "E-Commerce Mobile App",
    category: "Mobile Development",
    description: "Cross-platform shopping experience with real-time inventory management.",
    technologies: ["React Native", "Firebase", "Stripe", "Redux"],
    image: "https://images.unsplash.com/photo-1557821552-17105176677c?w=800&q=80"
  },
  {
    id: 4,
    title: "Enterprise Cloud Migration",
    category: "Cloud Services",
    description: "Seamless migration of legacy systems to AWS cloud infrastructure.",
    technologies: ["AWS", "Terraform", "Kubernetes", "Jenkins"],
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80"
  },
  {
    id: 5,
    title: "Real Estate Portal",
    category: "Web Application",
    description: "Interactive property listing platform with virtual tours and AI recommendations.",
    technologies: ["Next.js", "TypeScript", "Prisma", "Vercel"],
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
  },
  {
    id: 6,
    title: "Logistics Tracking System",
    category: "Custom Software",
    description: "Real-time shipment tracking with automated route optimization.",
    technologies: ["Angular", "Java", "MySQL", "Google Maps API"],
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80"
  },
  {
    id: 7,
    title: "Social Media Analytics Dashboard",
    category: "Web Application",
    description: "Comprehensive analytics platform for tracking social media performance across multiple channels.",
    technologies: ["React", "D3.js", "Node.js", "PostgreSQL"],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
  },
  {
    id: 8,
    title: "Smart Home IoT Platform",
    category: "Mobile Development",
    description: "Unified control system for smart home devices with voice integration.",
    technologies: ["Flutter", "AWS IoT", "GraphQL", "DynamoDB"],
    image: "https://images.unsplash.com/photo-1558002038-1055907df827?w=800&q=80"
  },
  {
    id: 9,
    title: "Educational Learning Management System",
    category: "Web Application",
    description: "Complete e-learning platform with video streaming and progress tracking.",
    technologies: ["Vue.js", "Laravel", "Redis", "S3"],
    image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&q=80"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    position: "CEO, TechStart Inc.",
    company: "TechStart Inc.",
    content: "Max Bien transformed our outdated systems into a modern, efficient platform. Their expertise in custom software development is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    position: "CTO, FinanceFlow",
    company: "FinanceFlow",
    content: "The team's dedication to quality and attention to detail resulted in a payment platform that exceeded our expectations. Highly recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    position: "Director of IT, HealthCare Plus",
    company: "HealthCare Plus",
    content: "Our cloud migration was seamless thanks to Max Bien. They handled everything professionally and kept us informed throughout the process.",
    rating: 5
  },
  {
    id: 4,
    name: "David Thompson",
    position: "Founder, ShopSmart",
    company: "ShopSmart",
    content: "The mobile app they developed for us has significantly increased our customer engagement. Excellent work from start to finish.",
    rating: 5
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of Cloud Computing in 2025",
    excerpt: "Explore the latest trends and innovations shaping the cloud computing landscape.",
    author: "Alex Martinez",
    date: "2025-01-15",
    category: "Cloud Services",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80"
  },
  {
    id: 2,
    title: "Building Scalable Web Applications",
    excerpt: "Best practices and architectural patterns for creating applications that grow with your business.",
    author: "Jennifer Lee",
    date: "2025-01-10",
    category: "Web Development",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
  },
  {
    id: 3,
    title: "Mobile-First Development Strategies",
    excerpt: "Why starting with mobile design leads to better user experiences across all devices.",
    author: "Robert Kim",
    date: "2025-01-05",
    category: "Mobile Development",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80"
  },
  {
    id: 4,
    title: "DevOps Culture: Bridging Development and Operations",
    excerpt: "How implementing DevOps practices can accelerate your software delivery pipeline.",
    author: "Maria Garcia",
    date: "2024-12-28",
    category: "DevOps",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=800&q=80"
  },
  {
    id: 5,
    title: "API Design Best Practices",
    excerpt: "Creating robust, developer-friendly APIs that stand the test of time.",
    author: "Alex Martinez",
    date: "2024-12-20",
    category: "Development",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=800&q=80"
  },
  {
    id: 6,
    title: "Security in Modern Web Applications",
    excerpt: "Essential security practices every development team should implement.",
    author: "Jennifer Lee",
    date: "2024-12-15",
    category: "Security",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80"
  },
  {
    id: 7,
    title: "Microservices Architecture Explained",
    excerpt: "Understanding the benefits and challenges of microservices in enterprise applications.",
    author: "Robert Kim",
    date: "2024-12-10",
    category: "Development",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80"
  },
  {
    id: 8,
    title: "AI and Machine Learning Integration",
    excerpt: "Practical approaches to integrating AI capabilities into your applications.",
    author: "Maria Garcia",
    date: "2024-12-05",
    category: "Web Development",
    readTime: "12 min read",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
  },
  {
    id: 9,
    title: "Container Orchestration with Kubernetes",
    excerpt: "Mastering Kubernetes for efficient container deployment and management.",
    author: "Alex Martinez",
    date: "2024-11-28",
    category: "Cloud Services",
    readTime: "11 min read",
    image: "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=800&q=80"
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Transforming Healthcare Delivery",
    client: "HealthCare Plus",
    industry: "Healthcare",
    challenge: "Outdated patient management system causing inefficiencies and compliance issues.",
    solution: "Developed a modern, HIPAA-compliant web application with real-time updates and automated reporting.",
    results: [
      "60% reduction in administrative time",
      "95% user satisfaction rate",
      "100% compliance with healthcare regulations",
      "3x faster patient check-in process"
    ],
    technologies: ["Vue.js", "Python", "PostgreSQL", "AWS"],
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80"
  },
  {
    id: 2,
    title: "E-Commerce Platform Scaling",
    client: "ShopSmart",
    industry: "Retail",
    challenge: "Existing platform couldn't handle peak traffic during sales events.",
    solution: "Redesigned architecture using microservices and implemented cloud-based auto-scaling.",
    results: [
      "99.9% uptime during peak events",
      "5x traffic handling capacity",
      "40% reduction in infrastructure costs",
      "2.5x increase in conversion rates"
    ],
    technologies: ["React Native", "Node.js", "MongoDB", "AWS"],
    image: "https://images.unsplash.com/photo-1557821552-17105176677c?w=800&q=80"
  },
  {
    id: 3,
    title: "Financial Services Modernization",
    client: "FinanceFlow",
    industry: "Finance",
    challenge: "Legacy payment system limited growth and lacked modern security features.",
    solution: "Built a new payment processing platform with advanced security and real-time analytics.",
    results: [
      "Processing 10M+ transactions monthly",
      "Zero security breaches",
      "50% faster transaction processing",
      "PCI DSS Level 1 compliance"
    ],
    technologies: ["React", "Java", "PostgreSQL", "Azure"],
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80"
  }
];

export const careers = [
  {
    id: 1,
    title: "Senior Full-Stack Developer",
    department: "Engineering",
    location: "San Francisco, CA / Remote",
    type: "Full-time",
    description: "Join our team to build cutting-edge web applications using modern technologies.",
    requirements: [
      "5+ years of experience with React and Node.js",
      "Strong understanding of software architecture",
      "Experience with cloud platforms (AWS/Azure)",
      "Excellent communication skills"
    ]
  },
  {
    id: 2,
    title: "Cloud Solutions Architect",
    department: "Cloud Services",
    location: "Remote",
    type: "Full-time",
    description: "Design and implement scalable cloud infrastructure for enterprise clients.",
    requirements: [
      "7+ years of experience in cloud architecture",
      "AWS/Azure certifications preferred",
      "Experience with Kubernetes and Docker",
      "Strong problem-solving skills"
    ]
  },
  {
    id: 3,
    title: "Mobile App Developer",
    department: "Engineering",
    location: "San Francisco, CA",
    type: "Full-time",
    description: "Create beautiful, performant mobile applications for iOS and Android.",
    requirements: [
      "3+ years of React Native or native mobile development",
      "Published apps on App Store or Google Play",
      "Understanding of mobile UI/UX principles",
      "Team player with agile experience"
    ]
  },
  {
    id: 4,
    title: "DevOps Engineer",
    department: "Operations",
    location: "Remote",
    type: "Full-time",
    description: "Streamline our development and deployment processes with modern DevOps practices.",
    requirements: [
      "4+ years of DevOps experience",
      "Expertise in CI/CD pipelines",
      "Experience with Terraform and Jenkins",
      "Strong scripting skills (Python/Bash)"
    ]
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "$5,000",
    duration: "per project",
    description: "Perfect for small businesses and startups",
    features: [
      "Basic web application",
      "Responsive design",
      "Up to 5 pages",
      "3 months support",
      "Basic SEO optimization",
      "Source code delivery"
    ],
    highlighted: false
  },
  {
    id: 2,
    name: "Professional",
    price: "$15,000",
    duration: "per project",
    description: "Ideal for growing businesses",
    features: [
      "Advanced web/mobile application",
      "Custom features & integrations",
      "Unlimited pages",
      "6 months support",
      "Advanced SEO & analytics",
      "Database design",
      "API development",
      "Performance optimization"
    ],
    highlighted: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    duration: "contact us",
    description: "For large-scale projects",
    features: [
      "Complex enterprise solutions",
      "Dedicated team",
      "Cloud infrastructure setup",
      "12+ months support",
      "Priority support 24/7",
      "Security audit",
      "DevOps implementation",
      "Training & documentation",
      "SLA guarantees"
    ],
    highlighted: false
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Max Bien",
    position: "Founder & CEO",
    bio: "With over 15 years in software development, Max leads the vision and strategy of the company.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80"
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    position: "CTO",
    bio: "Sarah brings expertise in cloud architecture and leads our technical innovation.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80"
  },
  {
    id: 3,
    name: "James Cooper",
    position: "Head of Development",
    bio: "James oversees our development teams and ensures delivery of high-quality solutions.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80"
  },
  {
    id: 4,
    name: "Emma Wilson",
    position: "Lead Designer",
    bio: "Emma creates beautiful, user-centered designs that bring our projects to life.",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&q=80"
  }
];

export const stats = [
  { label: "Projects Completed", value: "150+" },
  { label: "Happy Clients", value: "80+" },
  { label: "Team Members", value: "25+" },
  { label: "Years of Experience", value: "10+" }
];